"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AST = exports["default"] = /*#__PURE__*/function () {
  function AST(lexer) {
    _classCallCheck(this, AST);
    this.lexer = lexer;
  }
  return _createClass(AST, [{
    key: "ast",
    value: function ast(text) {
      this.tokens = this.lexer.lex(text);
      return this.program();
    }
  }, {
    key: "program",
    value: function program() {
      return {
        type: AST.Program,
        body: this.logicalOR()
      };
    }
  }, {
    key: "logicalOR",
    value: function logicalOR() {
      var left = this.logicalAND();
      var token;
      while (token = this.expect('|')) {
        left = {
          type: AST.LogicalExpression,
          left: left,
          operator: token.value,
          right: this.logicalAND()
        };
      }
      return left;
    }
  }, {
    key: "logicalAND",
    value: function logicalAND() {
      var left = this.unary();
      var token;
      while (token = this.expect('&')) {
        left = {
          type: AST.LogicalExpression,
          left: left,
          operator: token.value,
          right: this.unary()
        };
      }
      return left;
    }
  }, {
    key: "unary",
    value: function unary() {
      var token;
      if (token = this.expect('^')) {
        return {
          type: AST.UnaryExpression,
          operator: '!',
          argument: this.primary()
        };
      } else {
        return this.primary();
      }
    }
  }, {
    key: "primary",
    value: function primary() {
      var primary;
      if (this.expect('(')) {
        primary = this.logicalOR();
        this.consume(')');
      } else {
        primary = this.query();
      }
      return primary;
    }
  }, {
    key: "query",
    value: function query() {
      return {
        type: AST.Query,
        value: this.consume().value
      };
    }
  }, {
    key: "consume",
    value: function consume() {
      var token = this.expect.apply(this, arguments);
      if (!token) {
        throw 'Unexpected. Expecting: ' + (arguments.length <= 0 ? undefined : arguments[0]);
      }
      return token;
    }
  }, {
    key: "expect",
    value: function expect() {
      var token = this.peek.apply(this, arguments);
      if (token) {
        return this.tokens.shift();
      }
    }
  }, {
    key: "peek",
    value: function peek() {
      if (this.tokens.length) {
        var value = this.tokens[0].value;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        if (args.includes(value) || !args.length) {
          return this.tokens[0];
        }
      }
    }
  }]);
}();
_defineProperty(AST, "Program", 'Program');
_defineProperty(AST, "LogicalExpression", 'LogicalExpression');
_defineProperty(AST, "UnaryExpression", 'UnaryExpression');
_defineProperty(AST, "Query", 'Query');